import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#9e9e9e",
    },
    background: {
      default: "#121212",
      paper: "#1b1b1b",
    },
    text: {
      primary: "#dddddd",
      secondary: "#bdbdbd",
    },
    divider: "#424242",
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    body1: {
      color: "#ffffff",
    },
    body2: {
      color: "#bdbdbd",
    },
  },
});

export default darkTheme;
